import RequestAbstract from "../abstract";

export default class AccountingWithdrawalTransactions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/accounting-withdrawal-transactions";
    }

}
